/* Tour-script registry. */
import ceo from "./ceo";
import sales from "./sales";
import engineer from "./engineer";
import manager from "./manager";
import finance from "./finance";
import hr from "./hr";
import product from "./product";
import procurement from "./procurement";

// ADMIN reuses the CEO tour (HR + admin chunks already covered).
export const scripts = {
  CEO: ceo,
  ADMIN: ceo,
  SALES: sales,
  ENGINEER: engineer,
  MANAGER: manager,
  FINANCE: finance,
  HR: hr,
  PRODUCT: product,
  PROCUREMENT: procurement,
};

export const ROLE_LABELS = {
  CEO: "CEO (full overview)",
  ADMIN: "Admin / HR",
  SALES: "Sales",
  ENGINEER: "Engineer",
  MANAGER: "Manager",
  FINANCE: "Finance",
  HR: "HR",
  PRODUCT: "Product",
  PROCUREMENT: "Procurement",
  EMPLOYEE: "Employee",
  FRONT_DESK: "Front Desk Executive",
};
